import * as React from 'react';
import NavbarPortal from 'src/containers/NavbarPortal';
import i18n from 'src/resources/i18n';

import QuestionnaireFormContainer from '../../containers/QuestionnaireForm';
/**
 * アセスメント回答画面
 * @param props
 */
const AssessmentFormPortal: React.FC<any> = props => {
	const careerID = props.match.params.career_id;
	const classID = props.match.params.class_id;
	const id = props.match.params.questionnaire_id;
	const type = props.match.params.type;
	const flg = props.match.params.flg;

	return (
		<>
			<NavbarPortal title={i18n.t('AssessmentForm_0001')} />
			<QuestionnaireFormContainer
				careerID={careerID}
				classID={classID}
				id={id}
				type={type}
				flg={flg}
				assessmentFlg={true}
				onlyQuestionFlg={false}
			/>
		</>
	);
};

export default AssessmentFormPortal;



// WEBPACK FOOTER //
// ./src/pages/personal/AssessmentFormPortal.tsx